import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { JoinInterviewWrapper } = await import('./JoinInterviewWrapper');
    return {
        Component: JoinInterviewWrapper,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
